// 偏好专业
import React, { useState, useMemo, useEffect } from 'react';
import { Cascader, message, Modal } from 'antd';
import { ExclamationCircleOutlined, CheckCircleOutlined } from '@ant-design/icons';
import styles1 from './customCascader.module.scss';
import styles from './PreferredMajor.module.scss';
import setRequiredFields from './GaokaoxkStore'
import { SVGPureIcon } from "@/ui";
import { observer } from 'mobx-react-lite';


// 原始选项数据（不包含计数）
const RAW_OPTIONS = [
  {
    value: "本科",
    label: "本科",
    children: [
      {
        value: "哲学",
        label: "哲学",
        children: [{ value: "哲学类", label: "哲学类" }]
      },
      {
        value: "经济学",
        label: "经济学",
        children: [
          { value: "经济学类", label: "经济学类" },
          { value: "财政学类", label: "财政学类" },
          { value: "金融学类", label: "金融学类" },
          { value: "经济与贸易类", label: "经济与贸易类" }
        ]
      },
      {
        value: "法学",
        label: "法学",
        children: [
          { value: "法学类", label: "法学类" },
          { value: "政治学类", label: "政治学类" },
          { value: "社会学类", label: "社会学类" },
          { value: "民族学类", label: "民族学类" },
          { value: "马克思主义理论类", label: "马克思主义理论类" },
          { value: "公安学类", label: "公安学类" }
        ]
      },
      {
        value: "教育学",
        label: "教育学",
        children: [
          { value: "教育学类", label: "教育学类" },
          { value: "体育学类", label: "体育学类" }
        ]
      },
      {
        value: "文学",
        label: "文学",
        children: [
          { value: "中国语言文学类", label: "中国语言文学类" },
          { value: "外国语言文学类", label: "外国语言文学类" },
          { value: "新闻传播学类", label: "新闻传播学类" }
        ]
      },
      {
        value: "历史学",
        label: "历史学",
        children: [{ value: "历史学类", label: "历史学类" }]
      },
      {
        value: "理学",
        label: "理学",
        children: [
          { value: "数学类", label: "数学类" },
          { value: "物理学类", label: "物理学类" },
          { value: "化学类", label: "化学类" },
          { value: "天文学类", label: "天文学类" },
          { value: "地理科学类", label: "地理科学类" },
          { value: "大气科学类", label: "大气科学类" },
          { value: "海洋科学类", label: "海洋科学类" },
          { value: "地球物理学类", label: "地球物理学类" },
          { value: "地质学类", label: "地质学类" },
          { value: "生物科学类", label: "生物科学类" },
          { value: "心理学类", label: "心理学类" },
          { value: "统计学类", label: "统计学类" }
        ]
      },
      {
        value: "工学",
        label: "工学",
        children: [
          { value: "力学类", label: "力学类" },
          { value: "机械类", label: "机械类" },
          { value: "仪器类", label: "仪器类" },
          { value: "材料类", label: "材料类" },
          { value: "能源动力类", label: "能源动力类" },
          { value: "电气类", label: "电气类" },
          { value: "电子信息类", label: "电子信息类" },
          { value: "自动化类", label: "自动化类" },
          { value: "计算机类", label: "计算机类" },
          { value: "土木类", label: "土木类" },
          { value: "水利类", label: "水利类" },
          { value: "测绘类", label: "测绘类" },
          { value: "化工与制药类", label: "化工与制药类" },
          { value: "地质类", label: "地质类" },
          { value: "矿业类", label: "矿业类" },
          { value: "纺织类", label: "纺织类" },
          { value: "轻工类", label: "轻工类" },
          { value: "交通运输类", label: "交通运输类" },
          { value: "海洋工程类", label: "海洋工程类" },
          { value: "航空航天类", label: "航空航天类" },
          { value: "兵器类", label: "兵器类" },
          { value: "核工程类", label: "核工程类" },
          { value: "农业工程类", label: "农业工程类" },
          { value: "林业工程类", label: "林业工程类" },
          { value: "环境科学与工程类", label: "环境科学与工程类" },
          { value: "生物医学工程类", label: "生物医学工程类" },
          { value: "食品科学与工程类", label: "食品科学与工程类" },
          { value: "建筑类", label: "建筑类" },
          { value: "安全科学与工程类", label: "安全科学与工程类" },
          { value: "生物工程类", label: "生物工程类" },
          { value: "公安技术类", label: "公安技术类" }
        ]
      },
      {
        value: "农学",
        label: "农学",
        children: [
          { value: "植物生产类", label: "植物生产类" },
          { value: "自然保护与环境生态类", label: "自然保护与环境生态类" },
          { value: "动物生产类", label: "动物生产类" },
          { value: "动物医学类", label: "动物医学类" },
          { value: "林学类", label: "林学类" },
          { value: "水产类", label: "水产类" },
          { value: "草学类", label: "草学类" }
        ]
      },
      {
        value: "医学",
        label: "医学",
        children: [
          { value: "基础医学类", label: "基础医学类" },
          { value: "临床医学类", label: "临床医学类" },
          { value: "口腔医学类", label: "口腔医学类" },
          { value: "公共卫生与预防医学类", label: "公共卫生与预防医学类" },
          { value: "中医学类", label: "中医学类" },
          { value: "中西医结合类", label: "中西医结合类" },
          { value: "药学类", label: "药学类" },
          { value: "中药学类", label: "中药学类" },
          { value: "法医学类", label: "法医学类" },
          { value: "医学技术类", label: "医学技术类" },
          { value: "护理学类", label: "护理学类" }
        ]
      },
      {
        value: "管理学",
        label: "管理学",
        children: [
          { value: "管理科学与工程类", label: "管理科学与工程类" },
          { value: "工商管理类", label: "工商管理类" },
          { value: "农业经济管理类", label: "农业经济管理类" },
          { value: "公共管理类", label: "公共管理类" },
          { value: "图书情报与档案管理类", label: "图书情报与档案管理类" },
          { value: "物流管理与工程类", label: "物流管理与工程类" },
          { value: "工业工程类", label: "工业工程类" },
          { value: "电子商务类", label: "电子商务类" },
          { value: "旅游管理类", label: "旅游管理类" }
        ]
      },
      {
        value: "艺术学",
        label: "艺术学",
        children: [
          { value: "艺术学理论类", label: "艺术学理论类" },
          { value: "音乐与舞蹈学类", label: "音乐与舞蹈学类" },
          { value: "戏剧与影视学类", label: "戏剧与影视学类" },
          { value: "美术学类", label: "美术学类" },
          { value: "设计学类", label: "设计学类" }
        ]
      }
    ]
  },
  {
    value: "专科",
    label: "专科",
    children: [
      {
        value: "农林牧渔大类",
        label: "农林牧渔大类",
        children: [
          { value: "农业类", label: "农业类" },
          { value: "林业类", label: "林业类" },
          { value: "畜牧业类", label: "畜牧业类" },
          { value: "渔业类", label: "渔业类" }
        ]
      },
      {
        value: "资源环境与安全大类",
        label: "资源环境与安全大类",
        children: [
          { value: "资源勘查类", label: "资源勘查类" },
          { value: "测绘地理信息类", label: "测绘地理信息类" },
          { value: "石油与天然气类", label: "石油与天然气类" },
          { value: "煤炭类", label: "煤炭类" },
          { value: "金属与非金属矿类", label: "金属与非金属矿类" },
          { value: "气象类", label: "气象类" },
          { value: "环境保护类", label: "环境保护类" },
          { value: "安全类", label: "安全类" }
        ]
      },
      {
        value: "能源动力与材料大类",
        label: "能源动力与材料大类",
        children: [
          { value: "电力技术类", label: "电力技术类" },
          { value: "热能与发电工程类", label: "热能与发电工程类" },
          { value: "新能源发电工程类", label: "新能源发电工程类" },
          { value: "有色金属材料类", label: "有色金属材料类" },
          { value: "非金属材料类", label: "非金属材料类" },
          { value: "建筑材料类", label: "建筑材料类" },
          { value: "黑色金属材料类", label: "黑色金属材料类" }
        ]
      },
      {
        value: "土木建筑大类",
        label: "土木建筑大类",
        children: [
          { value: "建筑设计类", label: "建筑设计类" },
          { value: "城乡规划与管理类", label: "城乡规划与管理类" },
          { value: "土建施工类", label: "土建施工类" },
          { value: "建筑设备类", label: "建筑设备类" },
          { value: "建设工程管理类", label: "建设工程管理类" },
          { value: "市政工程类", label: "市政工程类" },
          { value: "房地产类", label: "房地产类" }
        ]
      },
      {
        value: "水利大类",
        label: "水利大类",
        children: [
          { value: "水文水资源类", label: "水文水资源类" },
          { value: "水利工程与管理类", label: "水利工程与管理类" },
          { value: "水土保持与水环境类", label: "水土保持与水环境类" },
          { value: "水利水电设备类", label: "水利水电设备类" }
        ]
      },
      {
        value: "装备制造大类",
        label: "装备制造大类",
        children: [
          { value: "机械设计制造类", label: "机械设计制造类" },
          { value: "机电设备类", label: "机电设备类" },
          { value: "轨道装备类", label: "轨道装备类" },
          { value: "船舶与海洋工程装备类", label: "船舶与海洋工程装备类" },
          { value: "航空装备类", label: "航空装备类" },
          { value: "汽车制造类", label: "汽车制造类" }
        ]
      },
      {
        value: "生物与化工大类",
        label: "生物与化工大类",
        children: [
          { value: "生物技术类", label: "生物技术类" },
          { value: "化工技术类", label: "化工技术类" }
        ]
      },
      {
        value: "轻工纺织大类",
        label: "轻工纺织大类",
        children: [
          { value: "轻化工类", label: "轻化工类" },
          { value: "包装类", label: "包装类" },
          { value: "印刷类", label: "印刷类" },
          { value: "纺织服装类", label: "纺织服装类" }
        ]
      },
      {
        value: "食品药品与粮食大类",
        label: "食品药品与粮食大类",
        children: [
          { value: "食品类", label: "食品类" },
          { value: "药品与医疗器械类", label: "药品与医疗器械类" },
          { value: "粮食类", label: "粮食类" }
        ]
      },
      {
        value: "交通运输大类",
        label: "交通运输大类",
        children: [
          { value: "道路运输类", label: "道路运输类" },
          { value: "铁道运输类", label: "铁道运输类" },
          { value: "水上运输类", label: "水上运输类" },
          { value: "航空运输类", label: "航空运输类" },
          { value: "管道运输类", label: "管道运输类" },
          { value: "城市轨道交通类", label: "城市轨道交通类" },
          { value: "邮政类", label: "邮政类" }
        ]
      },
      {
        value: "电子与信息大类",
        label: "电子与信息大类",
        children: [
          { value: "集成电路类", label: "集成电路类" },
          { value: "通信类", label: "通信类" }
        ]
      },
      {
        value: "医药卫生大类",
        label: "医药卫生大类",
        children: [
          { value: "中医药类", label: "中医药类" },
          { value: "护理类", label: "护理类" },
          { value: "眼视光类", label: "眼视光类" },
          { value: "康复治疗类", label: "康复治疗类" },
          { value: "公共卫生与卫生管理类", label: "公共卫生与卫生管理类" },
          { value: "健康管理与促进类", label: "健康管理与促进类" }
        ]
      },
      {
        value: "财经商贸大类",
        label: "财经商贸大类",
        children: [
          { value: "财政税务类", label: "财政税务类" },
          { value: "金融类", label: "金融类" },
          { value: "财务会计类", label: "财务会计类" },
          { value: "统计类", label: "统计类" },
          { value: "经济贸易类", label: "经济贸易类" },
          { value: "物流类", label: "物流类" }
        ]
      },
      {
        value: "旅游大类",
        label: "旅游大类",
        children: [
          { value: "旅游类", label: "旅游类" },
          { value: "餐饮类", label: "餐饮类" }
        ]
      },
      {
        value: "文化艺术大类",
        label: "文化艺术大类",
        children: [
          { value: "艺术设计类", label: "艺术设计类" },
          { value: "表演艺术类", label: "表演艺术类" },
          { value: "民族文化艺术类", label: "民族文化艺术类" },
          { value: "文化服务类", label: "文化服务类" }
        ]
      },
      {
        value: "新闻传播大类",
        label: "新闻传播大类",
        children: [
          { value: "新闻出版类", label: "新闻出版类" },
          { value: "广播影视类", label: "广播影视类" }
        ]
      },
      {
        value: "教育与体育大类",
        label: "教育与体育大类",
        children: [
          { value: "教育类", label: "教育类" },
          { value: "语言类", label: "语言类" },
          { value: "体育类", label: "体育类" }
        ]
      },
      {
        value: "公安与司法大类",
        label: "公安与司法大类",
        children: [
          { value: "公安管理类", label: "公安管理类" },
          { value: "侦查类", label: "侦查类" },
          { value: "法律实务类", label: "法律实务类" },
          { value: "法律执行类", label: "法律执行类" },
          { value: "司法技术类", label: "司法技术类" },
          { value: "安全防范类", label: "安全防范类" }
        ]
      },
      {
        value: "公共管理与服务大类",
        label: "公共管理与服务大类",
        children: [
          { value: "公共事业类", label: "公共事业类" },
          { value: "公共服务类", label: "公共服务类" },
          { value: "文秘类", label: "文秘类" }
        ]
      }
    ]
  }
];

const MAX_SELECTION = 8; // 最大选择数量为8

const PreferredMajor = (props) => {
  const [selectedValues, setSelectedValues] = useState([]);
  const [selectedFirstLevel, setSelectedFirstLevel] = useState(null);
  const [dropdownVisible, setDropdownVisible] = useState(false);
  const [showWarning, setShowWarning] = useState(false);
  // const [pendingFirstLevel, setPendingFirstLevel] = useState(null);

  // 当选中值变化时，更新一级选项选择状态
  useEffect(() => {
    if (setRequiredFields.optionalFields.preferredMajor1.length > 0) {
      // 获取所有一级值
      const firstLevelValues = setRequiredFields.optionalFields.preferredMajor1.map(path => path[0]);
      // 找出被选中的一级值
      const uniqueFirstLevels = [...new Set(firstLevelValues)];

      if (uniqueFirstLevels.length > 0) {
        setSelectedFirstLevel(uniqueFirstLevels[0]);
      }
    } else {
      setSelectedFirstLevel(null);
    }
  }, [setRequiredFields.optionalFields.preferredMajor1]);

  // 根据选中的值计算每个二级菜单的选中数量
  const options = useMemo(() => {
    // 计算每个二级选项下选中的三级选项数量
    const secondLevelCounts = {};
    setRequiredFields.optionalFields.preferredMajor1.forEach(path => {
      if (path.length >= 2) {
        const secondLevelKey = `${path[0]}-${path[1]}`;
        secondLevelCounts[secondLevelKey] = (secondLevelCounts[secondLevelKey] || 0) + 1;
      }
    });

    return RAW_OPTIONS.map(parent => {
      // 如果已选择了一级选项，但当前不是被选中的一级，则添加切换提示
      const isOtherFirstLevel = selectedFirstLevel !== null && parent.value !== selectedFirstLevel;

      const children = parent.children.map(child => {
        // 计算该二级菜单下所有三级选项的数量
        const totalGrandChildren = child.children?.length || 0;
        // 该二级菜单下已选的三级数量
        const key = `${parent.value}-${child.value}`;
        const selectedCount = secondLevelCounts[key] || 0;
        // 二级菜单的label
        const label = `${child.label} (${selectedCount}/${totalGrandChildren})`;

        return {
          ...child,
          label,
          children: child.children?.map(grandChild => ({ ...grandChild })),
        };
      });

      return {
        ...parent,
        children,
        label: parent.label
      };
    });
  }, [setRequiredFields.optionalFields.preferredMajor1, selectedFirstLevel]);
  function transformAndDeduplicate(data) {
    // 1. 扁平化为一维数组
    const flattened = data.reduce((acc, item) => acc.concat(item), []);

    // 2. 去重处理（保留顺序）
    const deduplicated = [];
    const seen = new Set();

    for (const item of flattened) {
      if (!seen.has(item)) {
        seen.add(item);
        deduplicated.push(item);
      }
    }

    return deduplicated;
  }

  const onChange = (value) => {
    // 检查是否超过最大选择数
    if (value.length > MAX_SELECTION) {
      setShowWarning(true);
      setTimeout(() => setShowWarning(false), 2000);
      message.warning(`最多只能选择${MAX_SELECTION}个科目`);
      return;
    }

    const result = transformAndDeduplicate(value);

    // 更新选择值
    setSelectedValues(value);
    setShowWarning(false);

    setRequiredFields.setOptionalFields({
      preferredMajor: result, // 更新 classification 属性
    });
    setRequiredFields.setOptionalFields({
      preferredMajor1: value
    });

    // 如果选择了最大数量，关闭下拉框
    if (value.length === MAX_SELECTION) {
      setDropdownVisible(false);
    }
  };

  //一级菜单触发方法
  const onLoadData = () => {
    setRequiredFields.clearPreferredMajor()
    setSelectedValues([])
  };

  // 处理一级菜单点击事件
  // const handleFirstLevelClick = (value) => {
  //   // 如果点击的是已选的一级菜单，不做处理
  //   if (value === selectedFirstLevel) {
  //     return;
  //   }

  //   // 如果当前有选中的一级菜单，并且用户点击了其他一级菜单
  //   if (selectedFirstLevel && value !== selectedFirstLevel) {
  //     // 检查当前是否有选中的科目
  //     if (selectedValues.length > 0) {
  //       // 设置待切换的一级菜单
  //       // setPendingFirstLevel(value);
  //       setRequiredFields.clearPreferredMajor()
  //       setSelectedValues([])
  //     } else {
  //       // 如果没有选中任何科目，直接切换
  //       setSelectedFirstLevel(value);
  //     }
  //   } else if (!selectedFirstLevel) {
  //     // 如果当前没有选中的一级菜单，直接设置
  //     setSelectedFirstLevel(value);
  //   }
  // };

  // 确认切换一级菜单
  // const confirmSwitchFirstLevel = () => {
  //   Modal.confirm({
  //     title: '切换专业类别',
  //     content: '切换专业类别将清空当前选择，是否继续？',
  //     okText: '确认',
  //     cancelText: '取消',
  //     onOk: () => {
  //       // 清空当前选择
  //       setSelectedValues([]);
  //       setSelectedFirstLevel(pendingFirstLevel);
  //       setPendingFirstLevel(null);
  //     },
  //     onCancel: () => {
  //       setPendingFirstLevel(null);
  //     },
  //   });
  // };

  // // 当有待切换的一级菜单时，弹出确认框
  // useEffect(() => {
  //   if (pendingFirstLevel) {
  //     confirmSwitchFirstLevel();
  //   }
  // }, [pendingFirstLevel]);

  const handleDropdownVisibleChange = (visible) => {
    setDropdownVisible(visible);
  };

  const dropdownRender = (menus) => (
    <div className="custom-dropdown-container">
      <div className={`selection-hint ${selectedValues.length === MAX_SELECTION ? 'completed' : ''}`} style={{ padding: '10px 0 0 10px', fontSize: '12px',
          color: '#00000080' }}>
        {`最多可选${MAX_SELECTION}个`}
        {/* {`（ ${selectedValues.length}/${MAX_SELECTION}）`} */}
      </div>

      {menus}
    </div>
  );

  const tagRender = (props) => {
    const { label, closable, onClose } = props;

    const handleClose = (e) => {
      e.preventDefault();
      e.stopPropagation();
    };
    const preferredMajorList=setRequiredFields?.optionalFields?.preferredMajor?.flat()

    return (
      <span className="custom-tag" style={{ color: '#006AFF', fontWeight:700 }}>
        {label}
        {closable && preferredMajorList?.length>3 && (
          <span className="tag-close-icon" onClick={handleClose}>
            、
          </span>
        )}
      </span>
    );
  };

  // 自定义字段名：使用路径作为值
  const fieldNames = {
    children: 'children',
    label: 'label',
    value: 'value'
  };

  return (
    <div>
      <Cascader
        className={styles1['custom-cascader']}
        popupClassName={styles["custom-cascader-dropdown"]}
        style={{ 
          width: 'auto', // 关键：设置为 auto
          minWidth: 76, // 保留最小宽度
          display: 'inline-block' // 确保宽度自适应
        }}
        multiple
        allowClear={false}
        placeholder="专业"
        options={options}
        value={setRequiredFields.optionalFields.preferredMajor1}
        onChange={onChange}
        open={dropdownVisible}
        onDropdownVisibleChange={handleDropdownVisibleChange}
        dropdownRender={dropdownRender}
        tagRender={tagRender}
        fieldNames={fieldNames}
        showCheckedStrategy={Cascader.SHOW_CHILD} // 只显示子节点
        maxTagCount={1}
        maxTagPlaceholder={(omittedValues) => (
          <span style={{ color: '#006AFF' }}>
            ...
          </span>
        )}
         // 自定义选择器右侧的下拉箭头
              suffixIcon={
                <SVGPureIcon
                name={dropdownVisible?"shangjant":"ArrowDown"}
                  className=''
                  style={{ width: 16, height: 16 }}
                />
              }
        
              // 自定义下拉菜单中的展开箭头
              expandIcon={
                (
                  <SVGPureIcon
                    name="ArrowRight"
                    className='text-black text-opacity-50'
                    style={{
                      width: 16,
                      height: 16,
                    }}
                  />
                )
              }
              optionRender={(option, state = {}) => {
                const huoquxuanz=setRequiredFields?.optionalFields?.preferredMajor?.flat(Infinity)            
                
                return (
                  <div 
                  onClick={option?.label === "本科" || option?.label === "专科" ? ()=>onLoadData() : undefined} // 仅在条件满足时添加点击事件
                  style={{color:huoquxuanz?.includes(option?.label)?"#006AFF":''}}>
                     {option?.label}
                  </div>
                );
              }}
        
        
      // 添加一级菜单点击事件处理
      // onClick={(event, node, extra) => {
      //     if (extra.level === 0) {
      //       handleFirstLevelClick(node.value);
      //     }
      //   }}
      />
    </div>
  );
};

export default observer(PreferredMajor);